import { initializeLogger } from '@seamless/logger';

import type { ConsolaReporter, ReporterLogOptions, ReporterOptions } from '../../types';

import { LOG_LEVEL } from '../../types/enums';

type DatadogReporterOptions = ReporterOptions & { tenant: string; env: string; service: string; version: string };

export class DatadogReporter implements ConsolaReporter {
  private config: DatadogReporterOptions;

  constructor(config: DatadogReporterOptions) {
    this.config = config;
  }

  log(message: string, options: ReporterLogOptions): void {
    const { enabled, env = 'PROD', namespace, tenant, service, version } = this.config;
    const { args, date, group, level } = options;

    const isAvailable = enabled && (level === LOG_LEVEL.ERROR || level === LOG_LEVEL.DEFAULT);

    if (isAvailable) {
      const logger = initializeLogger(namespace, {
        tenant,
        configs: {
          env,
          service,
          version,
        },
      });

      logger.error(`${message}`, { date, group, data: args });
    }
  }

  getOptions(): ReporterOptions {
    return this.config;
  }
}
